import { motion } from 'framer-motion';

const milestones = [
  { year: '2014', title: 'Foundation', description: 'Established with a vision to simplify financial consultancy' },
  { year: '2016', title: 'Expansion', description: 'Extended services to include government subsidies' },
  { year: '2018', title: 'Growth', description: 'Crossed 200+ successful client engagements' },
  { year: '2020', title: 'D2D Model', description: 'Launched comprehensive Documentation to Disbursement service' },
  { year: '2024', title: 'Leadership', description: '500+ clients served with 98% success rate' }
];

export const AboutTimeline = () => (
  <section className="py-24 bg-[#f8fafc]" data-testid="timeline-section">
    <div className="max-w-7xl mx-auto px-6 lg:px-8">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        className="text-center mb-16"
      >
        <h2 className="font-heading text-3xl sm:text-4xl font-semibold text-[#0f172a] mb-4">
          Our Journey
        </h2>
        <p className="text-[#64748b] max-w-2xl mx-auto">
          A decade of growth, learning, and delivering value to our clients.
        </p>
      </motion.div>

      <div className="relative">
        <div className="absolute left-1/2 transform -translate-x-1/2 h-full w-0.5 bg-gradient-to-b from-[#3b5998] to-[#00bcd4] hidden lg:block"></div>
        
        <div className="space-y-12">
          {milestones.map((milestone, index) => (
            <motion.div
              key={milestone.year}
              initial={{ opacity: 0, x: index % 2 === 0 ? -30 : 30 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5 }}
              className={`flex items-center gap-8 ${index % 2 === 0 ? 'lg:flex-row' : 'lg:flex-row-reverse'}`}
            >
              <div className={`flex-1 ${index % 2 === 0 ? 'lg:text-right' : 'lg:text-left'}`}>
                <div className="bg-white p-6 rounded-xl shadow-sm border border-slate-100 inline-block">
                  <span className="stat-number text-3xl font-semibold">{milestone.year}</span>
                  <h3 className="font-heading text-lg font-semibold text-[#0f172a] mt-2">{milestone.title}</h3>
                  <p className="text-[#64748b] text-sm mt-1">{milestone.description}</p>
                </div>
              </div>
              <div className="w-4 h-4 rounded-full bg-gradient-to-br from-[#3b5998] to-[#00bcd4] hidden lg:block relative z-10"></div>
              <div className="flex-1 hidden lg:block"></div>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  </section>
);
